<qv-create-bid-wrapper (initConfirmNavigation)="onInnerEmitConfirmNavigation($event)"></qv-create-bid-wrapper>
